<template>
  <div class="ELYXButton">
    <div class="ELYXButton__backdrop" v-if="backdropEnabled"></div>
    <button @click="callButton" :style="getCustomStyles">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    fontWeight: {
      type: String,
      default: "500",
    },
    backdropEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCustomStyles() {
      let styles = "";
      if (this.fontWeight) {
        styles = `font-weight: ${this.fontWeight};`;
      }
      return styles;
    },
  },
  methods: {
    callButton() {
      this.$emit("click");
    },
  },
};
</script>

<style>
.ELYXButton {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0px auto;
  position: relative;
}

.ELYXButton__backdrop {
  position: absolute;
  top: -4px;
  width: 250.64px;
  height: 51px;
  background: #dee0e7;
  border: 1px solid #ffffffe6;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border-radius: 360px;
  box-sizing: border-box;
}

.ELYXButton button {
  border: none;
  border-radius: 360px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  color: #ffffff;
  background: black;
}
.ELYXButton button:hover {
  background-color: #444;
}

@media (max-width: 400px) {
  .ELYXButton__backdrop {
    width: 238.72px;
    height: 49.5px;
  }
}
</style>
